import { useAdminAccess, useAuthStore } from '@/features/auth';
import { usePendingApprovalsStore } from '@/features/approvals';
import { useMessengerUnreadStore } from '@/features/messenger';
import { useDraftStore } from '@/features/tickets';
import type { TourStepContext } from '@/features/onboarding-tour';

export function useTourContext(): TourStepContext {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const { canAccess: canAccessAdmin } = useAdminAccess();
  const pendingApprovals = usePendingApprovalsStore((s) => s.pending);
  const messengerUnread = useMessengerUnreadStore((s) => s.unread);
  const hasDraft = useDraftStore((s) => s.draft != null);
  return { hasPermission, canAccessAdmin, pendingApprovals, messengerUnread, hasDraft };
}
